import { Form, Select, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useFormData } from './StepForm.hooks';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    const { countries, currencies, isCountriesLoading, isCurrenciesLoading } = useFormData();

    return (
        <Form.Part>
            <Text font='label' fontSize='medium' fontWeight='regular'>
                {messages.letUsKnow}
            </Text>

            <Select
                autocomplete
                required
                multiple
                name='accountUsage.transactionCountries'
                qa='transactionCountries'
                tagColor='blue20'
                label={messages.countriesInteractWith}
                placeholder={messages.countriesInteractWithPlaceholder}
                progress={isCountriesLoading}
                items={countries}
            />

            <Select
                autocomplete
                multiple
                name='accountUsage.collectionCurrencies'
                qa='collectionCurrencies'
                tagColor='blue20'
                label={messages.currenciesSendIn}
                placeholder={messages.currenciesSendInPlaceholder}
                progress={isCurrenciesLoading}
                items={currencies}
            />

            <Select
                autocomplete
                multiple
                name='accountUsage.paymentCurrencies'
                qa='paymentCurrencies'
                tagColor='blue20'
                label={messages.currenciesPayOut}
                placeholder={messages.currenciesPayOutPlaceholder}
                progress={isCurrenciesLoading}
                items={currencies}
            />
        </Form.Part>
    );
});

StepForm.displayName = 'StepForm';
